import { render, staticRenderFns } from "./ImpersonateEndedView.vue?vue&type=template&id=754602b1&scoped=true"
import script from "./ImpersonateEndedView.vue?vue&type=script&lang=js"
export * from "./ImpersonateEndedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754602b1",
  null
  
)

export default component.exports